import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/api';
import intl from 'react-intl-universal';
import Select from 'react-select';



//问题详情
export default class QuestionList extends Component {
  constructor(props) {
    super();
    this.state = {
       data:{question:'',solution:''}
     
    };
    
  }
  
  componentDidMount(){
    document.title = '常见问题'
   
    var data = this.props.location.query;
    if(data){
      var {question,solution} = data;
    this.setState({data:data}) 
      sessionStorage.setItem('data',JSON.stringify(data));  
    }else {
     let str =sessionStorage.getItem('data')
     if(str&&str.length>0){
       let strdata=JSON.parse(str)
       this.setState({data:strdata})    
     }else {
       this.setState({question:'没有找到',solution:'没有找到数据'})
     }    
    
    }
   
  }
  render() {
   let {data}=this.state

    return (
      <div  className='flex-column-container' style={{paddingLeft:12,paddingRight:12,flex:1,marginTop:20}}>
         
          <p>{'问:'+data.question}</p>
          <p>{data.solution}</p> 

      </div>
    )
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }
  
}



// WEBPACK FOOTER //
// ./src/views/person/QuestionDetail.js